const TOGGLE_HAMBURGER_MENU = "TOGGLE_HAMBURGER_MENU";

export {
  TOGGLE_HAMBURGER_MENU
}
